import { Box, Link, Stack, Typography } from '@mui/material';

import { RouterLink } from 'src/routes/components';

import { userType } from 'src/pages/chat/utils/get-nav-item';

import { Image } from 'src/components/image';

// ----------------------------------------------------------------------

type Props = {
  value: string;
  row: any;
  isSelectRecordDialog?: boolean;
  isSupportReport?: boolean;
  editHref?: (id: string) => string;
  interactionLocked?: boolean;
  restrictionMessage?: string;
};

// ----------------------------------------------------------------------

export function RowCellChannelName({
  value,
  row,
  isSelectRecordDialog,
  isSupportReport,
  editHref,
  interactionLocked = false,
  restrictionMessage = '',
}: Props) {
  const selectedProfileType = userType.find(
    (profile) => 'channelType' in row && profile.type === row.channelType
  );

  const getHref = () => {
    if (!('id' in row) || !editHref) return '#';
    return editHref(row.id);
  };

  return (
    <Box sx={{ gap: 2, display: 'flex', alignItems: 'center' }}>
      <Box sx={{ gap: 2, display: 'flex', alignItems: 'center' }}>
        <Stack sx={{ typography: 'body2', flex: '1 1 auto', alignItems: 'flex-start' }}>
          <Box sx={{ gap: 1, display: 'flex', alignItems: 'center' }}>
            <Image
              src={selectedProfileType?.icon}
              alt={selectedProfileType?.name}
              sx={{
                width: 25,
                height: 25,
                mr: 1,
                transition: 'all 0.3s ease-in-out',
                ...(!interactionLocked && {
                  '&:hover': {
                    transform: 'scale(1.2)',
                  },
                }),
              }}
            />
          </Box>
        </Stack>
      </Box>
      <Box sx={{ gap: 2, display: 'flex', alignItems: 'center', flex: 1, minWidth: 0 }}>
        <Stack sx={{ typography: 'body2', flex: '1 1 auto', alignItems: 'flex-start', minWidth: 0 }}>
          <Box sx={{ gap: 1, display: 'flex', alignItems: 'center' }}>
            {isSelectRecordDialog || isSupportReport || !editHref ? (
              <Typography variant="body2"> {value}</Typography>
            ) : (
              <Link
                component={RouterLink}
                href={getHref()}
                color="inherit"
                sx={{
                  cursor: 'pointer',
                  transition: 'all 0.2s ease-in-out',
                  '&:hover': {
                    color: 'primary.main',
                    transform: 'translateX(4px)',
                  },
                }}
              >
                <Typography variant="body2"> {value}</Typography>
              </Link>
            )}
          </Box>
          {interactionLocked && restrictionMessage ? (
            <Typography variant="caption" color="warning.main" sx={{ mt: 0.5, display: 'block' }}>
              {restrictionMessage}
            </Typography>
          ) : null}
        </Stack>
      </Box>
    </Box>
  );
}
